// import $ from "jquery";
// import 'bootstrap';

export function ajamLoadScripts(arr, callback, i){  // 2019-10-04
    i = i || 0 // old ipad compatibility 2019-10-08
    if (typeof(arr) == 'string'){ arr = [arr]}
    if (i < arr.length){
        var v = arr[i];
        var ext = v.split('.').slice(-1)[0]
        var attr = ext=='js'?'src':'href';
        // only if not loaded
        if (document.querySelectorAll(`[${attr}*="${v}"]`).length < 1 ){ //console.log(attr,v,document.querySelectorAll(`[${attr}*="${v}"]`))
            if (ext == 'js' ){
                var elem = document.createElement('script');
                elem.type = "text/javascript" // type
                elem.src = v  // url
            }else if (ext == 'css'){
                var elem = document.createElement('link');
                elem.rel = "stylesheet"  // type
                elem.href = v // url
            }
                elem.arr = arr
                elem.callback = callback
                elem.i = i
                elem.v = v
                elem.onload = function(){ console.log(`${i+1}/${arr.length}`, this.v);
                    ajamLoadScripts(this.arr, this.callback, ++this.i)
                }
                document.head.appendChild(elem);
        }else{
            console.warn((i+1) + '/' +arr.length, v, 'already loaded')
            ajamLoadScripts(arr, callback, ++i)
        }
    }else{
        if (typeof(callback) == 'function'){ console.log('run callback')
            callback()
        }
    }
    }

export function createSpanObj(obj){
    obj = obj                     == undefined  ?{text:[]}   :obj; //1
    obj = typeof obj              == 'string'   ?{text:[obj]}  :obj;
    obj = Array.isArray(obj) == true      ?{text:obj}:obj; // check me in yontenzod2018
    obj = Array.isArray(obj.text) == false      ?{text:[obj.text||'']}:obj; // check me in yontenzod2018

    return ( // return result from below
    `${
    obj.text.length > 0 // not empty
        ?obj.text.map(function(t){ // true loop with map
            return (
            typeof(t) == 'string'
                ?`<span class="${(obj.className||'Menu')}">${t}</span>` // if string
                :`<span class="${Object.keys(t)[0]+(obj.className||'Menu')}">${t[Object.keys(t)[0]]}</span>` // else as Object
            )
        }).join('') // join returned array to string
        :'<span></span>'// else ''
    }`)
    }

export function createMenu(obj){
    return createLiLinkFunctionObj(obj);
    }
export function createLiLinkFunctionObj(obj){ //console.log(obj)
    var obj = obj != undefined?obj:{};
    if (obj.className == 'dropdown-header'){
        return (
            `<li ${obj.id?`id="${obj.id}"`:``} class="${obj.className}">${createSpanObj(obj)}</li>`
        )
    }else if (obj.className == 'divider'){
        return (
            `<li ${obj.id?`id="${obj.id}"`:``}  role="separator" class="${obj.className}"></li>`
        )
    }else{
        if (obj.id != undefined){
            if (obj.clickFunction == undefined){
                obj.clickFunction = function(e){
                    console.log(e);
                }
            }
            if (navBar[obj.id] == undefined){ // check if obj.id is unique (is undefined)
                navBar[obj.id] = obj.clickFunction; // assign obj.clickFunction to navBar variable
            }else{
                obj.oldId = obj.id;
                var a = obj.id.match(/(.+?)(\d+)$/) // match menu/menu1
                obj.id = a == null
                    ?obj.id += '1' //
                    :a[1] + (++a[2]);
                navBar[obj.id] = obj.clickFunction; // assign obj.clickFunction to navBar variable
                console.log(obj.oldId,'already assigned. using: ',obj.id, 'pls check',obj) // warn that obj.id is not unique
            }
        }
    return ( // 2021-06-22 remove id in <a> ${//obj.id?` id="${obj.id}"`:''}
        `<li ${obj.id?`id="${obj.id}"`:``} ${obj.style?`style="${obj.style}"`:``}${obj.title?` title="${obj.title}"`:``}>
            <a${obj.clickFunction?` onclick="navBar.${obj.id}(this)"`:''}${obj.data?` data-data="${obj.data}"`:''}${(obj.href||obj.id)?` href="${'javascript:;'||obj.href||obj.id}"`:''}>${obj.glyphicon?`<span class="glyphicon glyphicon-${obj.glyphicon}">${obj.text!=""?"&nbsp;":"&zwj;"}</span>`:''}
                ${obj.imgsrc?`<img style="height:15px;margin-right:5px;" src="${obj.imgsrc}">`:''}
                ${createSpanObj(obj)}
                ${obj.buttons?Object.values(obj.buttons).map(button=>`<span ${button.clickFunction?(navBar[obj.id+button.id]=button.clickFunction,`onclick="navBar.${obj.id+button.id}(this)"`):''} ${button.class?`class="${button.class}"`:``} ${button.style?`style="${button.style}"`:``}>${button.text?button.text:''}</span>`).join(''):''}
            </a>
        </li>`
        )
    }
    }


export function createDropdownMenu(obj){
    return createLiDropdownObj(obj);
    }
export function createLiDropdownObj(obj){ //console.log(obj) //{text:'',className:'',lis[]}
    obj = obj != undefined?obj:{};
    return (
    `<li class="dropdown"${obj.id?` id="${obj.id}"`:''}${obj.style?` style="${obj.style}"`:''}>
        <a href="#" class="dropdown-toggle" data-toggle="dropdown" data-target="" role="button" aria-haspopup="true" aria-expanded="false">
            ${typeof(obj.text) == 'string'? obj.text:Array.isArray(obj.text)==true?obj.text.map(function(t){return (typeof(t) == 'string'?t:`<span class="${Object.keys(t)[0]+(obj.className||'Menu')}"${t.title?` title="${t.title}"`:``}>${t[Object.keys(t)[0]]}</span>`) }).join(''):''}
            ${obj.img?`<img id="${obj.id}Img" src="${obj.src?obj.src:''}" style="width:20px;height:auto;">`:''}
            <span class="caret"></span>
        </a>
        <ul class="dropdown-menu">
            ${Array.isArray(obj.lis) == true
                ?obj.lis.map(function(l){return createLiLinkFunctionObj(l)}).join('').replace(/\n+|\t+/g,"").replace(/> +</g,"><")
                :createLiLinkFunctionObj(obj.lis) }
        </ul>
    </li>`
    )
    }

export function createDropdownHeader(obj){
    var obj = obj != undefined?obj:{};
    return (
        `<li class="dropdown-header">
            ${obj.text?obj.text:''}
        </li>`
        )
    }
export function changeNavbarBrand(brand){
    $('.navbar-brand').html(brand);
    changeLanguageBarText(window.localStorage.getItem('defaultMenuLanguage'));
    }
export function appendNavbarLeft(left, pos){
    var id ="#navbarLeft";
    appendNavbar(id,left,pos)
    }
export function appendNavbarCenter(center, pos){
    var id ="#navbarCenter";
    appendNavbar(id,center,pos)
    }
export function appendNavbarRight(right, pos){
    var id ="#navbarRight";
    appendNavbar(id,right,pos)
    }
export function appendNavbar(id, data, pos){
    data = Array.isArray(data) == false?[data]:data;
    data.map(function(l){
        pos != undefined
            ?(pos>0)
                ?$(id).find(`>li:nth-child(${pos<$(id).find('>li').length?pos:$(id).find('>li').length})`).after(l)
                :$(id).find(`>li:nth-child(1)`).before(l)
            :$(id).append(l)
    })
    // changeLanguageBarText(defaultMenuLanguage);
    changeLanguageBarText(window.localStorage.getItem('defaultMenuLanguage'));
    }
export function appendNavbarDropdown(id,data,pos){
    data = Array.isArray(data) == false?[data]:data;
    data.map(function(l){
        pos != undefined
            ?(pos>0)
                ?$(id).find(`>ul>li:nth-child(${pos<$(id).find('>ul>li').length?pos:$(id).find('>ul>li').length})`).after(l)
                :$(id).find(`>ul>li:nth-child(1)`).before(l)
            :$(id).find('>ul').append(l)
    })
    changeLanguageBarText(window.localStorage.getItem('defaultMenuLanguage'));
    }

export function changeLanguageBarText(lang){
    lang = (lang == 'tib' || lang == 'chin' || lang == 'eng')?lang:'chin';
    ['tib','chin','eng'].forEach(function(v){
        if (lang != v){
            $(`#navbarNavbar [class^="${v}"]`).hide();
        }else{
            $('#navbarNavbar [class^="'+lang+'"]').show();
        }
    })
    // set title with 'lang' span text
    $('title').text($('.navbar-brand').find('span.'+lang+'Span').text())
    // save defaultMenuLanguage
    window.localStorage.setItem('defaultMenuLanguage',lang)
    }
export function getCSSRule(ruleName, deleteFlag) {                // Return requested style obejct
    ruleName=ruleName.toLowerCase();                       // Convert test string to lower case.
    if (document.styleSheets) {                            // If browser can play with stylesheets
        for (var i=document.styleSheets.length-1;i>=0;i--) { // For each stylesheet reverse
            var styleSheet=document.styleSheets[i];          // Get the current Stylesheet
            var ii=0;                                        // Initialize subCounter.
            var cssRule=false;                               // Initialize cssRule.
            do {                                             // For each rule in stylesheet
                if (styleSheet.cssRules) {                    // Browser uses cssRules?
                    cssRule = styleSheet.cssRules[ii];         // Yes --Mozilla Style
                } else {                                      // Browser usses rules?
                    cssRule = styleSheet.rules[ii];            // Yes IE style.
                }                                             // End IE check.
                if (cssRule)  {                               // If we found a rule...
                    if (cssRule.type == 1 &&  // check for CSSStyleRule (type 1): https://developer.mozilla.org/en-US/docs/Web/API/CSSRule#Type_constants
                        // match ruleName
                        cssRule.selectorText.toLowerCase()==ruleName) { //  match ruleName?
                    if (deleteFlag=='delete') {             // Yes.  Are we deleteing?
                        if (styleSheet.cssRules) {           // Yes, deleting...
                            styleSheet.deleteRule(ii);        // Delete rule, Moz Style
                        } else {                             // Still deleting.
                            styleSheet.removeRule(ii);        // Delete rule IE style.
                        }                                    // End IE check.
                        return true;                         // return true, class deleted.
                    } else {                                // found and not deleting.
                        return cssRule;                      // return the style object.
                    }                                       // End delete Check
                    }                                          // End found rule name
                }                                             // end found cssRule
                ii++;                                         // Increment sub-counter
            } while (cssRule)                                // end While loop
        }                                                   // end For loop
    }                                                      // end styleSheet ability check
    return false;                                          // we found NOTHING!
    }
export function getAllCSSRule(ruleNameNew, deleteFlag, compareFlag) {// Return requested style obejct
    var foundCssRules = [];
    ruleNameNew = ruleNameNew //.toLowerCase();            // Convert test string to lower case.
    if (document.styleSheets) {                            // If browser can play with stylesheets
        for (var i=document.styleSheets.length-1;i>=0;i--) { // For each stylesheet // from last
        var styleSheet=document.styleSheets[i];          // Get the current Stylesheet
        var ii=0;                                        // Initialize subCounter.
        var cssRule=false;                               // Initialize cssRule.
        do {
        try{                                               // For each rule in stylesheet
            if (styleSheet.cssRules) {                    // Browser uses cssRules?
                cssRule = styleSheet.cssRules[ii];         // Yes --Mozilla Style
            } else if (styleSheet.rules){                                      // Browser usses rules?
                cssRule = styleSheet.rules[ii];            // Yes IE style.
            }else{
                continue;
            }
        }catch(err){console.log(styleSheet.href,'Cors error for this css file. pls download and use localy.')}                                           // End IE check.
            if (cssRule)  {                               // If we found a rule...
                var cssRuleSelectorText = cssRule.selectorText  //.toLowerCase()
                ruleNameNew.split(/\, +| /g)
                .forEach(function(ruleName){ // may have multiple selectors
                    // check for CSSStyleRule (type 1): https://developer.mozilla.org/en-US/docs/Web/API/CSSRule#Type_constants
                    if ( (cssRule.type == 1) &&
                        // match ruleName
                        (
                            ( (compareFlag == undefined || compareFlag == '') &&  cssRuleSelectorText == ruleName)?true:
                            (compareFlag == 'start'  && cssRuleSelectorText.indexOf(ruleName) == 0)?true:
                            (compareFlag == 'center' && cssRuleSelectorText.indexOf(ruleName) > -1)?true:
                            (compareFlag == 'end'    && cssRuleSelectorText.indexOf(ruleName) == (cssRuleSelectorText.indexOf(ruleName).length-ruleName.length))?true:false
                        )
                    ){                                         //  matched type and ruleName so
                        if (deleteFlag=='delete') {            // Yes.  Are we deleteing?
                            if (styleSheet.cssRules) {         // Yes, deleting...
                                styleSheet.deleteRule(ii);     // Delete rule, Moz Style
                            } else {                           // Still deleting.
                                styleSheet.removeRule(ii);     // Delete rule IE style.
                            }                                  // End IE check.
                            //return true;                     // return true, class deleted.
                        } else {                               // found and not deleting.
                            foundCssRules.push(cssRule)
                            //return cssRule;                  // return the style object.
                        }                                      // End delete Check
                    }                                      // End found rule name
                })
            }                                             // end found cssRule
            ii++;                                         // Increment sub-counter
        } while (cssRule)                                // end While loop
    }                                                   // end For loop
    return (foundCssRules.length > 0?foundCssRules:[])
    }                                                      // end styleSheet ability check
    return [];                                             // we found NOTHING! // no stylesheets
    }
export function addCSSRule(ruleName) {                           // Create a new css rule
    // 2018-06-11
    if (document.styleSheets) {                            // Can browser do styleSheets?
        if (!getCSSRule(ruleName)) {                        // if rule doesn't exist...
            if (document.styleSheets[0].addRule) {           // Browser is IE?
                document.styleSheets[0].addRule(ruleName, null,0);      // Yes, add IE style
            } else {                                         // Browser is Moz?
                document.styleSheets[0].insertRule(ruleName+' { }', 0); // Yes, add Moz style.
            }                                                // End browser check
        }                                                   // End already exist check.
        return getCSSRule(ruleName);                       // return rule we just created.
    }                                                      // End browser ability check.
    // return false
    }


export function setCssText(cT,St,Vl,Pr){ console.log(cT,St,Vl,Pr)
    var re = RegExp(`(${St}): *(.+?);`)
    var temp = cT.match(re)
    var temp2 = temp!=null?cT.replace(re,`$1: ${Vl}${Pr?Pr:''};`):cT.slice(0,-1)+`${St}: ${Vl} ${Pr?Pr:''};`;
    console.log(temp2)
    return temp2
    }
export function selectorToRule(selector){
    return selector[0]=='.'
            ?'[class*="'+selector.slice(1)+'"]'
            :selector[0]=='#'
                ?'[id*="'+selector.slice(1)+'"]'
                :selector;
    }

export function setStyle(selector, style, value, cached){ // set all exact matching styles
    style = style.replace(/([A-Z])/g, function(g) { return '-' + g[0].toLowerCase() });
    cached = cached == undefined?cached = {}:cached
    selector.split(' ').forEach(function(v){
        if (cached[v] == undefined){
            cached[v] =  getCSSRule(v)||addCSSRule(v); // if not found add this rule
        }
        // console.log('cached[v]',typeof cached[v])
        cached[v] = cached[v].length?cached[v]:[cached[v]];
        // if(cached[v].length == undefined){
        //     // cached[v]['style'][style] = value // not always working
        //     // cached[v]['style'] = `${style}: ${value}` // this is ok 2020-05-15 !!! this removes all other css settings
        //     cached[v]['style'][style] = value;
        // }else{
        cached[v].forEach(function(vv,ii){
            vv['style'][style] = value
        })
        // }
        //console.log('from cache',v)
    })
  }
export function setStyleSingle(selector, style, value, cached){ // set only exact matching styles
    style = style.replace(/([A-Z])/g, function(g) { return '-' + g[0].toLowerCase() });
    cached = cached == undefined?cached = {}:cached
    var v = selector
    if (cached[v] == undefined){
        cached[v] =  getCSSRule(v)||addCSSRule(v); // if not found add this rule
    }
    // if(cached[v] != false){
    //     cached[v]['style'][style] = value;
    // }
    cached[v] = cached[v].length?cached[v]:[cached[v]];
    cached[v].forEach(function(vv,ii){
        vv['style'][style] = value
    })
    //console.log('from cache',v)
  }
export function setStyleAll(selector, style, value, cached){ //console.log(selector, style, value, cached) // set all selector matching styles
    style = style.replace(/([A-Z])/g, function(g) { return '-' + g[0].toLowerCase() });
    cached = cached == undefined?cached = {}:cached
    // var cached = {};
    selector.split(' ').forEach(function(v){ // feed each selector ".chin .chinTextP .chinTextA"
        if (cached[v] == undefined){ // not cached
            cached[v] = getAllCSSRule(v,'','start'); //add '', 'center' or 'start' to get all similar rules
            cached[v].length == 0 //not found //
                ?cached[v] = [addCSSRule(v)] // not found add
                :'';

        }
        cached[v] = cached[v].length?cached[v]:[cached[v]];
        cached[v].forEach(function(vv,ii){
            if(/^\+/.test(value)){ console.log('+',vv.selectorText,value,vv['style'][style])

                vv['style'][style] = `calc(${$(vv.selectorText).first().css('fontSize')} + 0.1em)`

            }else if(/^\-/.test(value)){ console.log('-',vv.selectorText,value,vv['style'][style])

                vv['style'][style] = `calc(${$(vv.selectorText).first().css('fontSize')} - 0.1em)`
            }else{
                //console.log(vv.selectorText,style,vv['style'][style], value)
                vv['style'][style] = value
                //console.log(vv.selectorText,style,vv['style'][style], value)
            }
        })
    })
    }

export function toggleMe(e,meSelector){
    var a = $(e).find('span.glyphicon')
    if ($(a).hasClass('glyphicon-remove')){
        $(a).removeClass('glyphicon-remove').addClass('glyphicon-ok');
        $(meSelector).toggle()
    }else{
        $(a).removeClass('glyphicon-ok').addClass('glyphicon-remove')
        $(meSelector).toggle()
    }
    }

export function toggleStyle(e,rules,style,trueValue,falseValue){
    var a = $(e).find('span.glyphicon')
    if ($(a).hasClass('glyphicon-remove')){
        $(a).removeClass('glyphicon-remove').addClass('glyphicon-ok');
        setStyle(rules,style, trueValue,window.cachedStyles)
    }else{
        $(a).removeClass('glyphicon-ok').addClass('glyphicon-remove')
        setStyle(rules,style, falseValue,window.cachedStyles)
    }
    }

export function toggleStyles(e,rules,style,trueValue,falseValue){
    var a = $(e).find('span.glyphicon').first()
    if ($(a).hasClass('glyphicon-remove')){
        $(a).removeClass('glyphicon-remove').addClass('glyphicon-ok');
        setStyleAll(rules,style, trueValue,window.cachedStyles)
    }else{
        $(a).removeClass('glyphicon-ok').addClass('glyphicon-remove')
        setStyleAll(rules,style, falseValue,window.cachedStyles)
    }
    }

export function toggleMe2(e, ifTrue, ifElse){
    var a = $(e).find('span.glyphicon')
    if ($(a).hasClass('glyphicon-remove')){
        $(a).removeClass('glyphicon-remove').addClass('glyphicon-ok');
        ifTrue();
    }else{
        $(a).removeClass('glyphicon-ok').addClass('glyphicon-remove')
        ifElse();
    }
    }

export function addBootstrapNavbar(bar){
    ////console.log('adding BootstrapNavbar')
    bar.navbarNavbar    = `<nav class="navbar navbar-default navbar-fixed-top" id = "navbarNavbar"></nav>`;
    bar.navbarContainer =
    `
    <div class="container-fluid" id="navbarContainer">
        <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbarBody" aria-expanded="false" aria-controls="navbar">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
        </button>
        <a class="navbar-brand" href="#">${bar.navbarBrandText}</a>
    </div>
    `;
    bar.navbarHeader = `<div class="navbar-header" id="navbarHeader"></div>`;
    bar.navbarBody   = `<div class="navbar-collapse collapse" id="navbarBody"></div>`;
    bar.navbarLeft   = `<ul class="nav navbar-nav navbar-left" id="navbarLeft">${bar.navbarLeftList.join('')}</ul>`;
    bar.navbarCenter = `<ul class="nav navbar-nav navbar-center" id="navbarCenter">${bar.navbarCenterList.join('')}</ul>`;
    bar.navbarRight  = `<ul class="nav navbar-nav navbar-right" id="navbarRight">${bar.navbarRightList.join('')}</ul>`;

    // bar.navbarLeft   = `<ul class="nav navbar-nav navbar-left" id="navbarLeft">${bar.navbarLeftList == undefined?navbar.navbarLeftList.join(''):bar.navbarLeftList.join('')}</ul>`;
    // bar.navbarCenter = `<ul class="nav navbar-nav navbar-center" id="navbarCenter">${bar.navbarCenterList == undefined? navbar.navbarCenterList.join(''):bar.navbarCenterList.join('')}</ul>`;
    // bar.navbarRight  = `<ul class="nav navbar-nav navbar-right" id="navbarRight">${bar.navbarRightList == undefined? navbar.navbarRightList.join(''):bar.navbarRightList.join('')}</ul>`;

    // make navbar append Container
    var res = $(bar.navbarNavbar).append(bar.navbarContainer)
    // navbarContainer: add header & body
    res.find('#navbarContainer').append(bar.navbarHeader)
    res.find('#navbarContainer').append(bar.navbarBody)
    // navbarBody: add left & center & right
    res.find('#navbarBody').append(bar.navbarLeft)
    res.find('#navbarBody').append(bar.navbarCenter)
    res.find('#navbarBody').append(bar.navbarRight)
    // place nav as 1st element in body
    $('body').prepend(res)
    // append style to head
    $('head').append(
    `
        <style id="bootstrapNavStyle">
            body{
                margin: 0;
                padding: 0;
                height: 100vh;
                /*width: 100vw;*/
                width: auto;
                display: grid;
                grid-template-rows: 50px 1fr;
                grid-template-columns: auto;
                grid-template-areas: 'navbar'
                                    'output';
            }
            .navbar{
                grid-area: navbar;
            }
            .output, #output{
                grid-area: output;
            }
        </style>
    `);
    // if($('#output').length <1 ){ console.log('#output not found' )}
    }

export function makeStylesMenu(){    // get all class name in #output exept for firbeaseui-auth-container *
    var classes={};
    $('#output [class]:not(#firebaseui-auth-container *)')
    .each(function(i,c){
            temp = $(c).attr('class')
            temp = temp.split(' ')
            Array.isArray(temp) == true
                ?temp.map(function(t){classes[t]=t})
                :classes[temp]=temp
    })
    // console.log(classes)
    classes = Object.keys(classes)
    // console.log(classes)
    var lis = []
    classes.sort();
    classes = classes.filter(function(f){return f})
    classes.forEach(function(v,i){ //console.log(v)
        lis.push({
            id: v,
            text: v,
            glyphicon: 'glyphicon-ok',
            clickFunction: function(e){//console.log('id',e)
                toggleMe2(e,
                    function(){
                        console.log(window.cachedStyles)
                        setStyle('.'+v,'display','', window.cachedStyles)
                    },function(){
                        console.log(window.cachedStyles)
                        setStyle('.'+v,'display','none', window.cachedStyles)
                    }
                )
            }
        })
        //window.cachedStyles[v] = getAllCSSRule('.'+v) // js not ready
    })

    lis.length > 0?appendNavbarLeft([createDropdownMenu({id:'Styles',text: 'Styles',lis: lis})]):'';
    }
